import type { GrowthBookType } from '../custom-typings/global';
import { GrowthBookServerSideFeatures, GrowthBookFeature } from '../model/experiment';

export default function joinExperimentsToString(
    growthBook?: GrowthBookType,
    ...features: string[]
) {
    if (!growthBook) return;
    const experiments: string[] = [];
    const getFeatureValue = (experimentKey: string, defaultValue: string = '') => {
        const featureValue = growthBook.getFeatureValue(experimentKey, defaultValue);
        featureValue !== defaultValue && experiments.push(`${experimentKey}.${featureValue}`);
    };
    if (features.length > 0) {
        features.forEach((i) => getFeatureValue(i));
    } else {
        Object.values({ ...GrowthBookServerSideFeatures, ...GrowthBookFeature }).forEach((feature) => {
            getFeatureValue(feature);
        });
    }

    if (experiments.length > 0) return experiments.join(',');

    return;
}
